import { Navigate } from 'react-router-dom'
import { getAdminToken } from './adminApi'

export function AdminEntry() {
  return getAdminToken() ? (
    <Navigate to="/admin/dashboard" replace />
  ) : (
    <Navigate to="/admin/login" replace />
  )
}
